import React from 'react';
var honorChildren = window.apiObj.zhengShuList.honor
var honorShuArray = []
honorChildren.forEach((element,index) => {
  honorShuArray.push(
    {
      name: 'block0',
      className: 'block',
      md: 8,
      xs: 24,
      key: `honor-${index}-${Date.now()}`,
      titleWrapper: {
        children: [
          {
            name: 'image',
            className: 'teams1-image',
            children:element.image,
            key: `image-${index}-${Date.now()}`,
          },
          { 
            name: 'title', 
            className: 'teams1-title', 
            children: element.title,
            key: `title-${index}-${Date.now()}`,
          },
          {
            name: 'content',
            className: 'teams1-job',
            children: element.title,
            key: `content-${index}-${Date.now()}`,
          },
        ],
      },
    },
  )
})
export const Teams10DataSource = {
  wrapper: { className: 'home-page-wrapper teams1-wrapper' },
  page: { className: 'home-page teams1' },
  OverPack: { playScale: 0.3, className: '' },
  titleWrapper: {
    className: 'title-wrapper',
    children: [
      {
        name: 'title',
        children: (
          <span>
            <p>公司荣誉</p>
          </span>
        ),
      },
    ],
  },
  block: {
    className: 'block-wrapper',
    children: honorShuArray 
  },
};
